"use client"

import { type ResolveRedirectsResponse } from "@/app/api/redirects/resolve/route"

/**
 * Client-side wrapper for `POST /api/redirects/resolve`. Fetches the route rather than
 * importing server code, like the other client actions; the redirect index is
 * server-only. Used as the SWR fetcher in `useSwrResolvedRedirects`.
 */
export const resolveRedirects = async (
    pathnames: string[]
): Promise<ResolveRedirectsResponse["resolved"]> => {
    const response = await fetch("/api/redirects/resolve", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pathnames })
    })

    if (!response.ok) {
        throw new Error(`redirects/resolve request failed: ${response.status}`)
    }

    const { resolved } = (await response.json()) as ResolveRedirectsResponse
    return resolved
}
